import { TextInput, Switch, Select } from "@mantine/core";
import { PageList, ENUM_FORM_DISPLAY } from "../../components/pageList";
import ActionCellRender from "../../components/actionCellRender";
import { IconTrash, IconPencil } from "@tabler/icons";
import TextEditor from "../../components/textEditor";
import EmailPlaceholderLegend from "../../components/emailPlaceholderLegend";

const apiEntity = "emailTemplate";

const EMAIL_TEMPLATE_TYPE_OPTIONS = [
  { value: "AR_FORM", label: "AR Form" },
  { value: "AR_FORM_PASSWORD", label: "AR Form password" },
  { value: "NOTIFICATION", label: "Notification" },
  { value: "NOTIFICATION_PASSWORD", label: "Notification password" },
  { value: "MCA", label: "MCA" },
  { value: "MCA_PASSWORD", label: "MCA password" },
  { value: "DEBIT_NOTE", label: "Debit Note" },
  { value: "DEBIT_NOTE_PASSWORD", label: "Debit Note password" },
  { value: "QUOTATION", label: "Quotation" },
  { value: "QUOTATION_PASSWORD", label: "Quotation password" },
  { value: "RENEWAL", label: "Renewal" },
  { value: "RENEWAL_PASSWORD", label: "Renewal password" },
];

function EmailTemplate() {
  return (
    <PageList
      title={"Email Templates"}
      apiEntity={apiEntity}
      tableSchema={tableSchema}
      formSchema={formSchema}
    />
  );
}

export default EmailTemplate;

const tableSchema = {
  showActionColumn: true,
  columns: [
    { field: "name", filter: true, headerName: "Name" },
    { field: "type", filter: true, headerName: "Type" },
    { field: "subject", filter: true, headerName: "Subject" },
    { field: "cc", filter: true, headerName: "CC" },
    { field: "bcc", filter: true, headerName: "BCC" },
    {
      field: "isDefault",
      headerName: "Default",
      cellRender: (col, data) => (data?.isDefault ? "Yes" : ""),
    },
    {
      field: "action",
      cellRender: ActionCellRender,
      isAction: true,
      actions: [
        {
          name: "edit",
          icon: IconPencil,
          props: {},
        },
      ],
      actionMenu: [
        {
          name: "delete",
          label: "Delete data",
          icon: IconTrash,
          props: {
            color: "red",
          },
        },
      ],
    },
  ],
  searchableFields: ["name", "type", "subject", "cc", "bcc", "searchText"],
};

const formSchema = {
  title: "Email Template",
  isMainForm: true,
  titleField: "name",
  display: {
    mode: ENUM_FORM_DISPLAY.LINK,
  },
  apiEntity,
  initialValues: {
    name: "",
    type: "AR_FORM",
    subject: "",
    body: "",
    cc: "",
    bcc: "",
    isDefault: false,
  },
  validate: {
    name: (value) =>
      !value || !String(value).trim() ? "Name is required" : null,
  },
  layout: {
    fields: [
      {
        name: "name",
        component: TextInput,
        props: {
          required: true,
          label: "Name",
          placeholder: "AR Form to client",
        },
      },
      {
        name: "type",
        component: Select,
        props: {
          required: true,
          label: "Type",
          data: EMAIL_TEMPLATE_TYPE_OPTIONS,
          searchable: false,
        },
      },
      {
        name: "isDefault",
        component: Switch,
        props: {
          label: "Default template for this type",
          type: "checkbox",
          mb: "sm",
        },
      },
      {
        name: "subject",
        component: TextInput,
        props: {
          required: true,
          label: "Subject",
          placeholder: "Advisor Recommendation Form for {{clientName}}",
        },
      },
      {
        name: "cc",
        component: TextInput,
        props: {
          label: "CC",
          placeholder: "Optional",
        },
      },
      {
        name: "bcc",
        component: TextInput,
        props: {
          label: "BCC",
          placeholder: "Optional",
        },
      },
      {
        name: "_placeholderLegend",
        component: EmailPlaceholderLegend,
        props: {},
      },
      {
        name: "body",
        component: TextEditor,
        props: {
          label: "Body",
        },
      },
    ],
  },
};
